module.exports = __webpack_public_path__ + "img/examen_fontamemtals.a39cb237.png";